import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "handleNavigationClick", "expandedNavigations", "setExpandedNavigations", "navigation", "activeListItem"];
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
// Derived from code from the Material UI project under the following license:
//
// The MIT License (MIT)
//
// Copyright (c) 2014 Call-Em-All
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//
import React, { useState } from "react";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ArrowRight from "@material-ui/icons/ArrowRight";
import Collapse from "@material-ui/core/Collapse";
import Toolbar from "@material-ui/core/Toolbar";
var styles = function styles(theme) {
  return {
    categoryHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    categoryHeaderPrimary: {
      color: "rgb(63,63,63)"
    },
    item: {
      paddingTop: 1,
      paddingBottom: 1,
      color: "rgb(63,63,63)",
      "&:hover,&:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.08)"
      }
    },
    itemCategory: {
      color: "rgb(63,63,63)",
      backgroundColor: "#f9fbff",
      boxShadow: "0 -1px 0 #404854 inset",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    firebase: {
      fontSize: 24,
      color: theme.palette.common.white
    },
    itemActiveItem: {
      color: "#00cdb1"
    },
    itemPrimary: {
      fontSize: "inherit",
      cursor: "default"
    },
    itemNested: {
      paddingLeft: theme.spacing(4)
    },
    itemIcon: {
      minWidth: "auto",
      marginRight: theme.spacing(1)
    },
    divider: {
      marginTop: theme.spacing(2)
    }
  };
};
function Navigator(_ref) {
  var classes = _ref.classes,
    handleNavigationClick = _ref.handleNavigationClick,
    expandedNavigations = _ref.expandedNavigations,
    setExpandedNavigations = _ref.setExpandedNavigations,
    navigation = _ref.navigation,
    activeListItem = _ref.activeListItem,
    other = _objectWithoutProperties(_ref, _excluded);
  function onItemClickHandler(item, index) {
    if (item.subNavigation && item.subNavigation.length > 0) {
      setNavigationExpanded(index, !isNavigationExpanded(index));
    } else {
      handleNavigationClick(item, index, null);
    }
  }
  function onSubItemClickHandler(item, index, subIndex) {
    handleNavigationClick(item, index, subIndex);
  }
  function isNavigationExpanded(navigationItemIndex) {
    return expandedNavigations[navigationItemIndex] === true;
  }
  function setNavigationExpanded(navigationItemIndex, isExpanded) {
    var expandedNavigationsClone = expandedNavigations.slice();
    expandedNavigationsClone[navigationItemIndex] = isExpanded;
    setExpandedNavigations(expandedNavigationsClone);
  }
  var currentSectionName = [];
  return /*#__PURE__*/React.createElement(Drawer, Object.assign({
    variant: "permanent"
  }, other), /*#__PURE__*/React.createElement(Toolbar, null), /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, navigation && navigation.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.label
    }, item.section && currentSectionName.indexOf(item.section) < 0 && currentSectionName.length > 0 && /*#__PURE__*/React.createElement(Divider, {
      className: classes.divider
    }), item.section && currentSectionName.indexOf(item.section) < 0 && currentSectionName.push(item.section) && /*#__PURE__*/React.createElement(ListItem, {
      key: item.section,
      className: classes.categoryHeader
    }, /*#__PURE__*/React.createElement(ListItemText, {
      classes: {
        primary: classes.categoryHeaderPrimary
      }
    }, item.section)), /*#__PURE__*/React.createElement(ListItem, {
      key: item.label,
      onClick: function onClick() {
        return onItemClickHandler(item, index);
      },
      button: true,
      className: clsx(classes.item, activeListItem === item && classes.itemActiveItem)
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      className: classes.itemIcon
    }, typeof item.icon === "string" || item.icon instanceof String ? /*#__PURE__*/React.createElement(Icon, null, item.icon) : item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.label,
      classes: {
        primary: classes.itemPrimary
      }
    }), item.subNavigation && item.subNavigation.length > 0 && (isNavigationExpanded(index) ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null))), /*#__PURE__*/React.createElement(Collapse, {
      in: isNavigationExpanded(index),
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(List, {
      component: "div",
      disablePadding: true
    }, item.subNavigation && item.subNavigation.map(function (subItem, subIndex) {
      return /*#__PURE__*/React.createElement(ListItem, {
        button: true,
        key: subItem.label,
        onClick: function onClick() {
          return onSubItemClickHandler(subItem, index, subIndex);
        },
        className: clsx(classes.item, classes.itemNested, activeListItem === subItem && classes.itemActiveItem)
      }, /*#__PURE__*/React.createElement(ListItemIcon, {
        className: classes.itemIcon
      }, /*#__PURE__*/React.createElement(ArrowRight, null)), /*#__PURE__*/React.createElement(ListItemText, {
        primary: subItem.label,
        classes: {
          primary: classes.itemPrimary
        }
      }));
    }))));
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)));
}
export default withStyles(styles)(Navigator);